import React from "react";
import PropTypes from "prop-types";
import CreateTeamModal from "./CreateTeamModal.js";
import { Button } from "./ui/Button.js";

const TeamDashboardHome = ({
  teams,
  leagues,
  user,
  showCreate = false,
  setShowCreate,
  onTeamCreated,
  hasActiveTeam = false,
}) => (
  <div className="team-dashboard-home">
    {showCreate && (
      <CreateTeamModal
        isOpen={showCreate}
        onClose={() => setShowCreate?.(false)}
        onTeamCreated={onTeamCreated}
        leagues={leagues}
        user={user}
      />
    )}

    {teams.length === 0 && !hasActiveTeam && !showCreate && (
      <div
        className="empty-state"
        style={{
          padding: "2rem 0",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "1rem",
        }}
      >
        <p style={{ margin: 0, color: "var(--color-text-secondary)" }}>
          {user
            ? "You haven't joined any teams yet."
            : "No teams available yet."}
        </p>
        {user && (
          <Button
            variant="primary"
            type="button"
            onClick={() => setShowCreate?.(true)}
          >
            Create Team
          </Button>
        )}
      </div>
    )}
  </div>
);

TeamDashboardHome.propTypes = {
  teams: PropTypes.array.isRequired,
  leagues: PropTypes.array.isRequired,
  user: PropTypes.object,
  showCreate: PropTypes.bool,
  setShowCreate: PropTypes.func,
  onTeamCreated: PropTypes.func,
  hasActiveTeam: PropTypes.bool,
};

export default TeamDashboardHome;
